import {
  deletePerformIndicator,
  getPerformIndicatorDetail,
  getPerformIndicatorList,
  savePerformIndicator,
} from '../services';

export default {
  namespace: 'performIndicator',
  state: {},
  effects: {
    // 绩效指标列表
    *getPerformIndicatorList({ payload }, { call }) {
      return yield call(getPerformIndicatorList, payload);
    },
    // 新增/编辑绩效指标
    *savePerformIndicator({ payload }, { call }) {
      return yield call(savePerformIndicator, payload);
    },
    // 绩效指标详情
    *getPerformIndicatorDetail({ payload }, { call }) {
      return yield call(getPerformIndicatorDetail, payload);
    },
    // 删除绩效指标
    *deletePerformIndicator({ payload }, { call }) {
      return yield call(deletePerformIndicator, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
